import { api } from './api'
import type { PlayerMe } from './types'

export type Gender = 'm' | 'f'

/** Пол нужен только для микст-турниров, поэтому спрашиваем его не при входе,
 *  а в момент первой записи в микст — и запоминаем в профиле. Окно с вопросом
 *  живёт в App; экраны вызывают ensureGender() перед записью. */
let known: Gender | null = null
let open: ((resolve: (g: Gender | null) => void) => void) | null = null
let saved: (() => void) | null = null

export function registerGenderPrompt(
  opener: (resolve: (g: Gender | null) => void) => void,
  onSaved: () => void,
): () => void {
  open = opener
  saved = onSaved
  return () => {
    open = null
    saved = null
  }
}

/** true — пол известен (уже был или только что указан); false — человек закрыл окно. */
export async function ensureGender(me: PlayerMe): Promise<boolean> {
  if (me.gender || known) return true
  const picked = await new Promise<Gender | null>((resolve) => (open ? open(resolve) : resolve(null)))
  if (!picked) return false
  await api.updateMe({ gender: picked })
  known = picked
  saved?.()
  return true
}

/** Свободные места микста по полу: половина мест — мужские, половина — женские. */
export function mixedFree(game: {
  max_players: number
  slots: { status: string; player: { gender: Gender | null } }[]
}): { m: number; f: number } {
  const half = Math.floor(game.max_players / 2)
  const joined = game.slots.filter((s) => s.status === 'joined')
  return {
    m: Math.max(half - joined.filter((s) => s.player.gender === 'm').length, 0),
    f: Math.max(half - joined.filter((s) => s.player.gender === 'f').length, 0),
  }
}
